//
//  http://tech-sketch.jp/2011/12/datepicker.html
//

function initShowCalendar() {
(function($) {
    // 既に定義されている場合はスキップ
    if ($.fn.showCalendar) {
        return;
    }

    // jQuery UIのdatepickerが利用可能かチェック
    if (!$.fn.datepicker) {
        console.warn('jQuery UI datepicker is not available yet');
        return;
    }
    /*
     * 祝日・非営業日の定義
     * （土・日は自動計算）
     * "yyyyMMdd":{type:?, title:"休日の名前"} を要素とするオブジェクト
     * type は任意の意味を持たせることが可能
     * （この例では、type:0は国民の祝日、type:1は企業独自の非営業日としている）
     *
     * var holidays = {
     *   "20120922": { type: 0, title: "秋分の日" },
     *   "20121008": { type: 0, title: "体育の日" },
     *   "20121103": { type: 0, title: "文化の日" },
     * };
    */

    function Holidays() {
        var instance;

        Holidays = function Holidays() {
            return instance;
        }

        Holidays.prototype = this;

        instance = new Holidays();
        instance.constructor = Holidays;

        (function() {
            $.ajax({
                type: "get",
                url: "/api/holidays",
                dataType: "json",
                async: false,
                success: function(data, statusText, jqXHR) {
                    instance.list = data;
                }
            });
        }());

        return instance;
    }

    $.fn.showCalendar = function(options) {
        if (options == undefined) options = {};

        // 選択できる日（最小）
        if (!options['minDate']) {
            options['minDate'] = new Date();
        }

        // 選択できる日（最大）
        if (!options['maxDate']) {
            if (!options['months']) {
                options['months'] = 12;
            }
            var max = new Date();
            max.setMonth(max.getMonth() + options['months']);
            options['maxDate'] = max;
        }

        var defaultOptions = {
            dateFormat: 'yy-mm-dd',
            onSelect: false,         // 日付選択後の処理
            regional: 'ja',
            showAnim: 'blind',
            duration: 'fast',
            numberOfMonths: 2,
            hideIfNoPrevNext: true,
            beforeShowDay: function(day) {
                var holidays = new Holidays();
                var holiday = holidays.list[ $.format.date(day, 'yyyy-MM-dd') ];
                if (holiday) {
                    switch (holiday.type) {
                    case 0: // 祝日
                        return [ true, 'date-holiday0', holiday.title ];
                        break;
                    case 1: // 店休日
                        return [ false, 'date-holiday1', holiday.title ];
                        break;
                    case 2: // 時間限定
                        return [ true, 'date-holiday1', holiday.title ];
                        break;
                    }
                } else {
                    switch (day.getDay()) {
                      case 0: // 日曜日
                        return [ true, 'date-sunday' ];
                        break;
                      case 6: // 土曜日
                        return [ true, 'date-saturday' ];
                        break;
                      default:
                        return [ true, '' ];
                        break;
                    }
                }
            }
        };

        $(this).datepicker($.extend(defaultOptions, options));

        return this;
    };

})(jQuery);
}

// 初回は即座に実行
initShowCalendar();

// 関数を公開（windowオブジェクトに追加）
if (typeof window !== 'undefined') {
    window.initShowCalendar = initShowCalendar;
}

